import { TEMPLATES } from "utils/constants";
import NoLevels from "./NoLevels";

const Templates = {
  [TEMPLATES.PRODUCT_NO_LEVELS]: NoLevels,
};
export default Templates;
